<template>
	<Modal @close="closeMailModal" :draggable="false">
		<template slot="title">Mail</template>
		<template slot="body">
			<div style="width: 800px; height: 550px;">
				<input type="hidden" name="send_address" />
				<input type="hidden" name="send_name" />
				<div>
					<div class="mail_top_box">
						<div class="mail_user">
							<dl>
								<dt>Send Address</dt>
								<dd>{{ mail.send_address }}</dd>
							</dl>
						</div>
						<div class="mail_user">
							<dl>
								<dt class="mail_name_dt">Send Name</dt>
								<dd>{{ mail.send_name }}</dd>
							</dl>
						</div>
					</div>

					<div class="address_wrap">
						<div class="mail_address_int">
							<span class="mail_address_text">Mail Address</span>
							<div class="mail_address_box" id="bcc_address_box">
								<div class="attached_address" v-for="(value, index) in toList" :key="index">
									<span>{{ value }}</span>
								</div>
							</div>
						</div>
					</div>

					<div class="address_wrap">
						<div class="mail_address_int">
							<span class="mail_address_text">CC</span>
							<div class="mail_address_box" id="bcc_address_box">
								<div class="attached_address" v-for="(value, index) in ccList" :key="index">
									<span>{{ value }}</span>
								</div>
							</div>
						</div>
					</div>

					<div class="address_wrap">
						<div class="mail_address_int">
							<span class="mail_address_text">BCC</span>
							<div class="mail_address_box" id="bcc_address_box">
								<div class="attached_address" v-for="(value, index) in bccList" :key="index">
									<span>{{ value }}</span>
								</div>
							</div>
						</div>
					</div>

					<div class="mail_contents">
						<div class="mc_int_box">
							<span class="mail_address_text">Subject</span>
							<p>
								<label>
									<input type="search" class="tbl_int" placeholder="" v-model="mail.subject" disabled />
								</label>
							</p>
							<div class="mc_textarea">
								<label>
									<textarea rows="7" name="content" v-model="mail.content" disabled></textarea>
								</label>
							</div>
						</div>
						<div class="mc_int_box">
							<span class="mail_address_text">Attachment</span>
							<div class="attact_file_box">
								<ul>
									<li v-for="(value, index) in mail.mailFile" :key="index">
										<em> {{ value.exportName }} <button type="button" class="btn btn-default btn-xs" @click="downloadFile(value)">Download</button> </em>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="popup_bottom">
				<a href="javascript:void(0);" class="gray_bt" @click="closeMailModal">Cancel</a>
			</div>
		</template>
	</Modal>
</template>
<script>
import Modal from '@/components/common/Modal';
import { apiFileDownload } from '@/api/util';

export default {
	name: 'mailDetail',
	components: { Modal },
	props: {
		mail: {
			mailRecipient: [],
		},
	},
	methods: {
		closeMailModal() {
			this.$emit('close');
		},

		downloadFile(file) {
			let url = `/api/mail/file/${file.file_no}`;
			apiFileDownload(url, file.exportName);
		},
	},

	computed: {
		toList() {
			return this.mail.mailRecipient.filter(user => user.state === 'to').map(user => user.recipient);
		},
		ccList() {
			return this.mail.mailRecipient.filter(user => user.state === 'cc').map(user => user.recipient);
		},
		bccList() {
			return this.mail.mailRecipient.filter(user => user.state === 'bcc').map(user => user.recipient);
		},
	},
};
</script>
